import { fromJS } from 'immutable'
import {
  SALE_PRODUCT_EXPORT_REQUEST,
  SALE_PRODUCT_EXPORT_SUCCESS,
  SALE_PRODUCT_EXPORT_FAILURE,
  SALE_PRODUCT_EXPORT_RESET,
} from '../../actions/sale-product/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SALE_PRODUCT_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case SALE_PRODUCT_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case SALE_PRODUCT_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case SALE_PRODUCT_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sale-product/sale-product-export-reducer.js